
export default {
  props: {
    artist: {
      type: Object,
      default: null
    },
    date: {
      type: String,
      default: ''
    }
  },
  computed: {
    activeOverlayClass() {
      // This is a really ugly but quick way to display for the different
      // festival days a different color: first day=yellow | second day=green
      return new Date(this.date).getDate() === 21 ? 'st-green' : 'st-yellow';
    },
    activeDay() {
      // This is a really ugly but quick way to display for the different
      // festival days a different color: first day=yellow | second day=green
      return new Date(this.date).getDate() === 21 ? 'day-1' : 'day-2';
    }
  }
};
